'use client';

import * as React from 'react';
import { useField, useDefaultizedDateTimeField } from '@mui/x-date-pickers/internals';
import { useSplitFieldProps } from '@mui/x-date-pickers/hooks';
import { rangeValueManager, getRangeFieldValueManager } from "../internals/utils/valueManagers.js";
import { validateDateTimeRange } from "../validation/index.js";
export const useSingleInputDateTimeRangeField = inProps => {
  const props = useDefaultizedDateTimeField(inProps);
  const {
    forwardedProps,
    internalProps
  } = useSplitFieldProps(props, 'date-time');
  const fieldValueManager = React.useMemo(() => getRangeFieldValueManager({
    dateSeparator: internalProps.dateSeparator
  }), [internalProps.dateSeparator]);
  return useField({
    forwardedProps,
    internalProps,
    valueManager: rangeValueManager,
    fieldValueManager,
    validator: validateDateTimeRange,
    valueType: 'date-time'
  });
};